const api = require("./api");

export default {

	getAdmins() {
		return api(
			{
				url:     "/admins/getAll",
				method:  "get",
				headers: {
					"X-TOKEN": localStorage.getItem("token") || "",
					"X-LOGIN": localStorage.getItem("login") || ""
				}
			}
		);
	},

	newAdmin(data) {
		return api(
			{
				url:     "/admins/add",
				method:  "post",
				headers: {
					"X-TOKEN": localStorage.getItem("token") || "",
					"X-LOGIN": localStorage.getItem("login") || ""
				},
				data:    data
			}
		);
	},

	getAdminByLogin(login) {
		return api(
			{
				url:     `/admins/get/${login}`,
				method:  "get",
				headers: {
					"X-TOKEN": localStorage.getItem("token") || "",
					"X-LOGIN": localStorage.getItem("login") || ""
				}
			}
		);
	},

	updateAdmin(data) {
		return api(
			{
				url:     `/admins/update`,
				method:  "put",
				headers: {
					"X-TOKEN": localStorage.getItem("token") || "",
					"X-LOGIN": localStorage.getItem("login") || ""
				},
				data:    data
			}
		);
	},

	deleteAdmin(login) {
		return api(
			{
				url:     `/admins/delete/${login}`,
				method:  "delete",
				headers: {
					"X-TOKEN": localStorage.getItem("token") || "",
					"X-LOGIN": localStorage.getItem("login") || ""
				}
			}
		);
	}
};
